module.exports = __webpack_public_path__ + "static/img/report3D_cover_1.cd33af0f.png";